export interface AvisoObraItem {
    id: number;
    idOrganismoCentral: number;
    idDireccion: number;
    codigoSrt: string | null;
    superficieM2: number;
    cantidadPlantas: number;
    descripcionObra: string;
    fechaInicio: string;
    fechaFin: string;
    fechaAlta: string;
    idUsuarioAlta: number | null;
    fechaActualizacion: string;
    idUsuarioActualizacion: number | null;
    fechaBaja: string | null;
    idUsuarioBaja: number | null;
    motivoBaja: string | null;
    idTipoResolucion: number;
    idEstadosAvisoObra: number;
    idEstablecimiento: number | null;
    programaSeguridadPresentado: boolean;
    direccion: Direccion;
    responsables: ResponsableItem[];
    extensionesObra: any[];
    suspensionesObra: any[];
    avisosObraActividadesEspeciales: ActividadEspecialItem[];
    avisosObraTiposSubtipos: TipoSubtipoObraItem[];
}

export interface Provincia {
    id: number;
    nombre: string;
}

export interface Localidad {
    id: number;
    nombre: string;
    provincia: Provincia;
    codigoPostal: number;
}

export interface Direccion {
    id: number;
    calle: string;
    altura: string;
    piso: string | null;
    departamento: string | null;
    latitud: string;
    longitud: string;
    localidad: Localidad;
}

export interface ResponsableItem {
    idResponsable: number;
    nombre: string;
    apellido: string;
    cuitCuilCuip: string | null;
    tituloHabilitante: string | null;
    nroMatricula: string | null;
    entidadOtorgante: string | null;
}

export interface ActividadEspecialItem {
    idAvisoObraActividad: number;
    idAvisoObra: number;
    idActividad: number;
    codigoActividad: number;
    descripcionActividad: string;
    idResolucion: number | null;
    fechaInicio: string | null;
    fechaFin: string | null;
}

export interface TipoSubtipoObraItem {
    idTipoObra: number;
    idSubtiposObra: number[];
}

export interface AvisoObraListParams {
    page?: number;
    limit?: number;
    search?: string;
    idEstado?: number;
    idTipoObra?: number;
    fechaInicioDesde?: string;
    fechaInicioHasta?: string;
}

export interface ActividadEspecialItem {
    id: number;
    codigo: number;
    descripcion: string;
    actividad: boolean;
}

export interface AvisoObraListResponse {
    data: AvisoObraItem[];
    totalCount: number;
    skip: number;
    take: number;
}

export interface AvisoObraDetailResponse {
    data: AvisoObraItem | any;
}

export interface TipoObraItem {
    id: number;
    nombre: string;
    subtipos: SubtipoObraItem[];
}
export interface SubtipoObraItem {
    id: number;
    codigo: number;
    descripcion: string;
    idTipoAvisoObra: number;
}

export interface TipoResolucionItem {
    id: number;
    name: string;
    codigo?: string;
    requierePrograma: boolean;
    descripcion: string;
}
export enum ResponsableObraEnum {
    SUBCONTRATISTA = 1,
    COMITENTE = 2,
    CONTRATISTA_PRINCIPAL = 3
}

export interface ContratistaFormItem {
    idResponsableObra: number;
    nombreResponsableObra: string;
    cuit: string;
    razonSocial: string;
}

export interface CreateAvisoObraDTO {
    id?: number;
    idTipoResolucion: number;
    latitud: number;
    longitud: number;
    superficieM2: number;
    cantidadPlantas: number;
    idProvincia: number;
    idLocalidad: number;
    fechaInicio: Date;
    fechaFin: Date;
    calleRuta: string;
    numeroKm: string;
    departamento: string;
    descripcionObra: string;
    codigoPostal: number;
    fechaPresentacionPrograma?: Date | null;
    programaSeguridadPresentado: boolean;
    idOrganismoCentral: number;
    pdfPrograma?: File;
}

export interface ResponsableFormItem {
    nombre: string;
    apellido: string;
    cuit: string;
    idCargo: number;
    cargoNombre?: string;
    idRepresentacion: number;
    representacionNombre?: string;
    idTipoContratacion: number;
    tipoContratacionNombre?: string;
    titulo?: string;
    matricula?: string;
    entidadOtorgante?: string;
    responsableFormulario?: boolean;
}
